import { useMemo } from "react";
import type { PlacingTableRow } from "~pages/FinalStandings/types/placingTableRow";

type Props = {
  rows: PlacingTableRow[];
  searchText: string;
};

const getNameFullLocal = (row: PlacingTableRow): string | null | undefined => row.entity?.nameFullLocal ?? row.person?.nameFullLocal;

export const useFilteredFinalPlacings = ({ rows, searchText }: Props): PlacingTableRow[] => {
  return useMemo(() => {
    if (!searchText) {
      return rows;
    }

    const lowerSearchText = searchText.toLowerCase();

    return rows.filter((row) => getNameFullLocal(row)?.toLowerCase()?.includes(lowerSearchText));
  }, [rows, searchText]);
};
